<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iv"></a>
<p class="copy-1">First published in Great Britain in 2022 by</p>
<p class="copy">Pen &amp; Sword Military</p>
<p class="copy">An imprint of</p>
<p class="copy">Pen &amp; Sword Books Ltd</p>
<p class="copy">Yorkshire – Philadelphia</p>
<p class="copy-2">Copyright © Bob Paterson 2022</p>
<p class="copy-2">ISBN 978 1 52676 446 1</p>
<p class="copy">eISBN 978 1 52676 447 8</p>
<p class="copy-2">The right of Bob Paterson to be identified as Author of this work</p>
<p class="copy">has been asserted by him in accordance with the Copyright,</p>
<p class="copy">Designs and Patents Act 1988.</p>
<p class="copy-2">A CIP catalogue record for this book is</p>
<p class="copy">available from the British Library.</p>
<p class="copy-2">All rights reserved. No part of this book may be reproduced or</p>
<p class="copy">transmitted in any form or by any means, electronic or mechanical</p>
<p class="copy">including photocopying, recording or by any information storage</p>
<p class="copy">and retrieval system, without permission from the Publisher</p>
<p class="copy">in writing.</p>
<p class="copy-2">Pen &amp; Sword Books Limited incorporates the imprints of Atlas,</p>
<p class="copy">Archaeology, Aviation, Discovery, Family History, Fiction, History,</p>
<p class="copy">Maritime, Military, Military Classics, Politics, Select, Transport,</p>
<p class="copy">True Crime, Air World, Frontline Publishing, Leo Cooper,</p>
<p class="copy">Remember When, Seaforth Publishing, The Praetorian Press,</p>
<p class="copy">Wharncliffe Local History, Wharncliffe Transport, Wharncliffe</p>
<p class="copy">True Crime and White Owl.</p>
<p class="copy-2">For a complete list of Pen &amp; Sword titles please contact</p>
<p class="copy-2">PEN &amp; SWORD BOOKS LIMITED</p>
<p class="copy">47 Church Street, Barnsley, South Yorkshire, S70 2AS, England</p>
<p class="copy">E-mail: <span class="weblink"><a href="mailto:enquiries@pen-and-sword.co.uk"><span class="underline">enquiries@pen-and-sword.co.uk</span></a></span></p>
<p class="copy">Website: <span class="weblink"><a href="http://www.pen-and-sword.co.uk" target="_blank"><span class="underline">www.pen-and-sword.co.uk</span></a></span></p>
<p class="copy-2">Or</p>
<p class="copy-2">PEN AND SWORD BOOKS</p>
<p class="copy">1950 Lawrence Rd, Havertown, PA 19083, USA</p>
<p class="copy">E-mail: <span class="weblink"><a href="mailto:Uspen-and-sword@casematepublishers.com"><span class="underline">Uspen-and-sword@casematepublishers.com</span></a></span></p>
<p class="copy">Website: <span class="weblink"><a href="http://www.penandswordbooks.com" target="_blank"><span class="underline">www.penandswordbooks.com</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?1e072cd4